// extracted by mini-css-extract-plugin
module.exports = {"banner__specialty":"styles_banner__specialty__G8oAH","pulse":"styles_pulse__OrNSb","jump":"styles_jump__wNWIf","wiggle":"styles_wiggle__whh_z"};